(function () {
  const SWATCH_SELECTOR = '.card__swatch-link';
  const MEDIA_SELECTOR = '.card__media';
  const CARD_SELECTOR = '.card-wrapper';
  const IMG_SELECTOR = '.card__media img:first-child';
  const SWATCH_PREVIEW_CLASS = 'card-wrapper--swatch-preview';
  const MEDIA_HOVER_CLASS = 'card-wrapper--media-hover';

  // True on touch devices / any device without reliable hover support.
  const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function getCard(el) {
    return el ? el.closest(CARD_SELECTOR) : null;
  }

  function getPrimaryImg(card) {
    return card.querySelector(IMG_SELECTOR);
  }

  function applyVariantImage(link) {
    const card = getCard(link);
    if (!card) return;
    card.classList.add(SWATCH_PREVIEW_CLASS);
    const img = getPrimaryImg(card);
    if (!img) return;
    const src = link.dataset.variantImage;
    const srcset = link.dataset.variantImageSrcset;
    if (!src) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', src);
    if (srcset) {
      img.setAttribute('srcset', srcset.trim());
    } else {
      img.removeAttribute('srcset');
    }
  }

  function restoreImage(link) {
    const card = getCard(link);
    if (!card) return;
    card.classList.remove(SWATCH_PREVIEW_CLASS);
    const img = getPrimaryImg(card);
    if (!img || !img.dataset.originalSrc) return;
    img.setAttribute('src', img.dataset.originalSrc);
    if (img.dataset.originalSrcset) {
      img.setAttribute('srcset', img.dataset.originalSrcset);
    } else {
      img.removeAttribute('srcset');
    }
  }

  function bind() {
    const swatches = document.querySelectorAll(SWATCH_SELECTOR);
    const cards = document.querySelectorAll(CARD_SELECTOR);

    swatches.forEach(function (el) {
      // Desktop: hover previews, click navigates to variant URL.
      el.addEventListener('mouseenter', function () { applyVariantImage(el); });
      el.addEventListener('mouseleave', function () { restoreImage(el); });

      // Touch: first tap previews (sticky). Re-tapping the same swatch
      // navigates, so there's still a path to the variant page.
      if (isTouch) {
        el.addEventListener('click', function (e) {
          const card = getCard(el);
          if (!card) return;
          if (el.dataset.previewActive === 'true') {
            delete el.dataset.previewActive;
            return; // let the click navigate
          }
          e.preventDefault();
          // Clear any other swatch's previewActive flag on this card.
          card.querySelectorAll(SWATCH_SELECTOR).forEach(function (other) {
            if (other !== el) delete other.dataset.previewActive;
          });
          applyVariantImage(el);
          el.dataset.previewActive = 'true';
        });
      }
    });

    cards.forEach(function (card) {
      const media = card.querySelector(MEDIA_SELECTOR);
      if (!media) return;
      card.addEventListener('mousemove', function (e) {
        const rect = media.getBoundingClientRect();
        const inside =
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom;
        card.classList.toggle(MEDIA_HOVER_CLASS, inside);
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove(MEDIA_HOVER_CLASS);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('focusin', function (e) {
    const link = e.target.closest(SWATCH_SELECTOR);
    if (link) applyVariantImage(link);
  });

  document.addEventListener('focusout', function (e) {
    const link = e.target.closest(SWATCH_SELECTOR);
    if (link) restoreImage(link);
  });
})();
